import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-lieferant.master-view.html',
    styleUrls: ['./ktostamm-lieferant.master-view.scss']
})
export class KtostammLieferantMasterView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
